import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceCreatePayload } from 'api/actions/remote-source-create/remote-source-create-payload';
import { RemoteSourceCreatePathParameters } from 'api/actions/remote-source-create/remote-source-create-path-parameters';
import { RemoteSourceCreateResponse } from 'api/actions/remote-source-create/remote-source-create-response';

type RemoteSourceCreateQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceCreate action.
 */
export const remoteSourceCreateActionPath = new SweetPath<keyof RemoteSourceCreatePathParameters>(
  '/api/remote-source/create',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceCreate actions.
 */
export default function createRemoteSourceCreateAction(axios: AxiosInstance) {
  return function remoteSourceCreateAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: RemoteSourceCreateQueryParameters;
    payload: RemoteSourceCreatePayload;
  }) {
    const path = remoteSourceCreateActionPath.original;

    return axios.request<RemoteSourceCreateResponse, RemoteSourceCreateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
